export default "/images/claritask-light.svg?a2b20651703a363c0cce42b8805cc343";